import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth36: ToothDataEntry = {
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.3,197.4l-2.6-21.8L4,106.7l-2.1-17.4v-11l1.9-11.1,2.1-7.8,3.8-7.2,1.9-3,3.5-1.6,5.3-.3,5.7.8,4,.9,22.3-9.2,20.7-4.3,22.6,5.4,51.3,2.9,24.8,12.9,4.8,3.5,4,1.1,10,5.1,19.1-.8,7.8,3.8,4.5,8.3,1.1,8.1.6,6.7v17.2l-1.1,16.1-1.9,12.7-3.2,17.2-5.1,19.3-6,15.6-3.2,7.3-4,8.4c-97.7,34.4-173-8.8-173-8.8Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M137.6,160.5a20.8,20.8 0 1,1 -41.6,0a20.8,20.8 0 1,1 41.6,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M25.9,188.1s25.7.9,33.4.9,13.4-4.9,13.4-13.8V36.2l-23.6,4.3-19,8.8-7.7-1.4-6.8.7-3.8,1.3-4.1,4.5-2.4,7.1-1.9,7.5-.9,10.2.2,18,3.3,17.5,20,73.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M163.2,52.6l22.8,13.9h8.9l13.6-1.1,10,6.1,3.9,9.3,1.4,16.4-1.8,22.1-2.1,23.2-4.6,21.8-3.2,10.4-7.5,20-27.5-1.2c-7.6,0-13.2-5-13.2-12.7-3.4-31.5-.7-128.1-.7-128.1h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.3,197.4l-.2-13.2-2.3-16.5L2.7,97.2l-.2-18,.9-10.2,1.9-7.5,2.4-7.1,4.1-4.5,3.9-1.3h-.1s6.8-.7,6.8-.7l7.7,1.4,12.8-4.8,10.2-3.2,11.3-3.6,8.9-1.5,23.3,5.7c-10.3,38.6,27.4,147.1,6.5,176.6-46.8-3.6-76.8-21.1-76.8-21.1Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M103.1,218.5c20.6-36.5-17.7-138.3-6.4-176.7l32.5,1.3,20.1,1.3h0s36.8,22.1,36.8,22.1h8.9l13.6-1.1,10,6.1,3.9,9.3,1.4,16.4-1.8,22.1-2.1,23.2-4.6,21.8-3.2,10.4-7.5,20-5.4,11.5c-50.9,18.2-96.1,12.3-96.1,12.3Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.3,197.4s74.6,42.7,173,8.8l-4.9,16.2s-66.1,36.5-167.6-7l-.5-18.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'8.4 117.1 35.4 147.8 42 97.4 63.4 157.5 79.4 97.4 99.3 160.6 117.6 101.2 137.5 160.6 155.2 100.5 174.3 160.6 188.8 102.1 199.8 150.2 222.1 115.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'154.9 217 141.1 226.1 158.1 234.8 144.2 244 159.9 252.1 146.7 260.9 160.8 268.1 148 276.6 164.2 284.9 151.6 293.1 164.6 299.7 152 308 166.2 315.2 152.9 324 166.2 330.7 152.9 339.5 165.4 346 152.4 354.5 167.5 362.2 152.3 372.2 166.8 379.8 151.8 389.6 166.9 397.3 152.1 407 169.1 415.8 155.6 424.8 171.5 433 155.3 443.5 170.4 451.3 155.8 460.9 171.8 469 156.4 479.2 172.1 487.3 156.7 500.7',
				'90 495.7 86.6 481.5 71.3 481.5 75.3 468.4 57.7 463.9 69.6 452 49.4 444 64.5 436.2 48.3 425.7 64.2 417.5 50.7 408.5 67.7 399.7 52.9 390 68 382.3 53 372.5 67.5 364.9 52.3 354.9 67.4 347.2 54.4 338.7 66.9 332.2 53.6 323.4 66.9 316.7 53.6 307.9 67.8 300.7 55.2 292.4 68.2 285.8 55.6 277.6 71.8 269.3 59 260.8 73.1 253.6 59.9 244.8 75.6 236.7 61.7 227.5 78.7 218.8 64.9 209.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'22.9 352.1 41.5 372.1 59.5 351.7 80.9 374 102.8 351.7 120.9 374.9 140.9 355.5 157.7 372.1 171.7 354.1 184.9 374 196.6 355.1',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '26 152.4 14.2 134.5 11.6 114.9 12 75.7 14.2 61.8 20.7 44.1 32.9 32 51.4 24.4 69.1 20.9 88.7 21.4 126.1 12.4 152.9 11.9 189.7 23.9 206.2 39.7 213 56.9 216 114.9 213.1 127.3 200.6 165 187 179.7 170 187.1 153.3 192.7 142 194.9 111.1 195.2 90.9 192.8 65.9 183.7 26 152.4',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M59.3,71l19.4,10.3s16.9,9,0,21.3-15.7,11.3-15.7,11.3l-42.7,28.7-6.3-7.8-2.1-16.8-.3-33.2,1.5-13.5,1.2-11.4,4.2-10.5,40.8,21.6Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M208.1,47.5l-31.4,27-11.2,9.4s-13.8,7.8-2.5,20.6l9.6,14.4,27.8,41.9c10.3-7.6,14.8-46.6,14.8-46.6l-.4-41.9-2.1-13-2.4-8.1s-2.2-3.7-2.2-3.7Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M172.6,118.9s-25.4-11.6-30.2-9.1-5.8,4.7-9.9,22.8,7.7,62.4,7.7,62.4l16.5-3,9.1-2.7,9.6-4.4,6-3.6,5.8-1.4,12.6-12.9.6-6.2-27.8-41.9Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M20.3,142.6l42.7-28.7s26.5-6.8,46,9.6,26-12.1,33.4-13.7-5.4,1.6-9.7,22.9c-3.1,19.3,3.3,45.2,7.7,62.4h-29.3c0,0-21.1-3-21.1-3l-24.1-8.4-31.2-23.8-8.7-7.5-5.7-9.8Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M18.6,49.3l5.1-7.6,9.6-9.7,17.4-7.2,18.4-3.9,20.7.2,19.8-3.8s5.4,16.6,6.1,25.6c-3,9.7,5.3,23.7,5.3,23.7-23.2-1.3-26.7,21.8-61.7,4.4l-40.8-21.6h0Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M109.7,17.3l16.4-4.9,26.8-.5,8,3.1,10.6,2.7,9.5,3.6,8.7,2.6,5.5,6,5.2,4.1,5.9,5.7,1.9,7.8-31.4,27s-13.7,3.3-18.3,3.9-9.2.6-15.9-5.1-21.5-6.7-21.5-6.7c-5.9-10.8-7.2-17.7-5.3-23.7,0,0-.7-6.9-6-25.7h0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M67.9,74.7c25.8,9.5,34.6-10.2,53.1-8.1s15.7,2.1,21.5,6.7,9.5,6.1,15.9,5.1l18.3-3.9c-.2,4.3-27.4,13.6-13.7,30l9.6,14.4s-22.9-10.6-30.2-9.1c-1.9-.3-9.4,11.5-13.1,14.9-9.9,9-18.5.5-20.3-1.2-23.7-15.9-46-9.6-46-9.6,0,0,11.8-8.7,15.8-11.5,14.2-10.9,5.3-17.9-5.8-24s-13.7-7.4-13.7-7.4l8.6,3.7Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'13.6 92.1 39.1 120.2 45.3 74.3 65.1 129.1 80.3 74.3 98.7 132 115.9 77.7 134.4 132 150.9 77 168.9 132 182.5 78.5 192.9 122.2 213.4 90.8',
			],
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M193,324.3l3.5,6.9,8,22.9,4.7,22.4,1.3,17.1.7,15.2-1.6,11.1-3.7,15.3-8.1,15.2-10.8,11.8-18.5,6.9-18.5-1.6-38.6-2.1-19.8,8.1-18.3,2.8-25.4.9-13.6-4.4-9.7-7.4-6.3-9.7-5.8-18.2-.4-12.5,1.1-15.5,3.5-18.2,15.1-58.8s39.3-25.5,161.2-8.1Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M132.4,358.8a20.8,20.8 0 1,1 -41.6,0a20.8,20.8 0 1,1 41.6,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.1,350.1s-18.1,67.1-16.5,74.6c1.5,7.1-3.8,50.9,43.7,51.9,11.4.2,15.3-1.1,15.3-1.1v-109.6s2.5-15.3-10.5-16.5-32,.7-32,.7Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M200.9,344.4s27.7,83.8-11.7,115.6c-5.1,6.3-21.2,7.5-21.2,7.5h-15.1v-105.7s-1.4-14,11.2-14.6c12.6-.7,36.8-2.7,36.8-2.7h0Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M197.3,331.3s40.9,79.2-7.4,128.1c-6.4,6.5-20.8,8-20.8,8l-55.4-2.3s-11.8-33.5,10.1-49.4c16-11.7-5.7-97.5-5.7-97.5,32.6-.5,76,6,76,6l3.3,7.1Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.7,336s-19.7,81.2-18.1,88.7c1.5,7.1-3.8,49.6,43.7,51.9,27.5,1.4,57.4-11.5,57.4-11.5,0,0-11.8-33.3,10.1-49.4,15.9-10.7-5.7-97.5-5.7-97.5-65.5.6-86.3,14.2-86.3,14.2l-1.1,3.6Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.8,332.4s41.3-25.3,161.2-8.1l-5.1-14.2s-86-12.4-153.5,4.3l-1.1,8.3-1.5,9.7Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'16.7 410.1 41.2 383.1 47 427.2 66.1 374.6 80.5 427.2 98.5 372 114.8 424 132.5 372 148.3 424.6 165.6 372 178.7 423.3 188.6 381.1 208.2 411.4',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'162 17.5 176.3 35.1 158.9 39.5 174.3 52.9 158.6 61 174 71.2 158 79.3 172.6 88.9 157.5 96.7 173.7 107.2 157.8 115.4 171.3 124.4 154.3 133.2 169.1 142.9 154 150.6 169 160.4 154.5 168 169.7 178 154.6 185.7 167.6 194.2 155.1 200.7 168.4 209.5 155.1 216.2 168.4 225 154.2 232.2 166.8 240.5 153.8 247.1 166.4 255.3 150.2 263.6 163 272.1 148.9 279.3 162.1 288.1 146.4 296.2 160.3 305.4 143.3 314.1 157.1 323.2',
				'67.1 330.5 80.9 321.4 63.9 312.7 77.8 303.5 62.1 295.4 75.3 286.6 61.2 279.4 74 270.9 57.8 262.6 70.4 254.4 57.4 247.8 70 239.5 55.8 232.3 69.1 223.5 55.8 216.8 69.1 208 56.6 201.5 69.6 193 54.5 185.3 69.7 175.3 55.2 167.7 70.2 157.9 55.1 150.2 69.9 140.5 52.9 131.7 66.4 122.7 50.5 114.5 66.7 104 51.6 96.2 66.2 86.6 51.1 73.9 65.6 68.3 57.8 53.4 76.4 50.8 70.7 37.4 88.8 23.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'194.7 189.9 183.1 171 169.8 190.9 155.8 172.9 139.1 189.5 119 170.1 100.9 193.3 79 171 57.6 193.3 39.7 172.9 21 192.9',
			],
		},
	},
};
